import getShipStationAppOrigin from 'utils/getShipStationAppOrigin';

// These all point at production. The one exception is a local ss-ui: when it
// is the host that launched us — framed us, or opened us in a tab — the links
// follow it, so they can be exercised against the app under test instead of
// landing on a production host the developer is signed out of.
const APP_URL = getShipStationAppOrigin();

export const SHIP_STATION_ROUTES = {
  LOGIN: 'https://signin.shipstation.com/login',
  SHIP_FROM_LOCATIONS: `${APP_URL}/settings/warehouses`,
  CARRIERS: `${APP_URL}/settings/carriers`,
  STORES: `${APP_URL}/settings/stores`,
  SENDER_EMAILS: `${APP_URL}/settings/senderemails`
};

// Help-center articles live on the support host rather than the app host.
export const SHIP_STATION_HELPER_ROUTES = {
  DOMAIN_AUTHENTICATION_HELP:
    'https://help.shipstation.com/hc/en-us/articles/23751509328923-Configure-Domain-Authentication-in-ShipStation'
};
